import type { RouterRepository } from "../repositories/router-repository";
import type {
  UpdateRouterRequest,
  RouterInfoResponse
} from "../../domain/types/router";
import { AppError } from "../../shared/utils/error-handler";

export class RouterUseCase {
  constructor(private routerRepository: RouterRepository) {}

  async updateRouter(
    routeId: number,
    request: UpdateRouterRequest,
  ): Promise<RouterInfoResponse> {
    try {
      return await this.routerRepository.updateRouter(routeId, request);
    } catch (error) {
      throw new AppError(
        String(error) || "라우터 정보 수정에 실패하였습니다.",
        "COMPANY_CREATION_FAILED",
        error,
      );
    }
  }
}
